import template from './labor-project-cost-breakdown-modal.html';
import controller from './labor-project-cost-breakdown-modal.controller';

const LaborProjectCostBreakdownModalConfig = {
  animation: true,
  template,
  controller,
  controllerAs: '$ctrl',
  size: 'lg',
  backdrop: true,
  windowClass: 'hmodal-info animated fadeIn labor-project-cost-breakdown-modal'
};

export default LaborProjectCostBreakdownModalConfig;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/modals/labor-project-cost-breakdown-modal/labor-project-cost-breakdown-modal.component.js